import "core-js/modules/web.dom-collections.iterator.js";
import { http, passthrough } from "msw";
import loadBlob from "../../../../lib/Core/loadBlob";
import MappableMixin from "../../../../lib/ModelMixins/MappableMixin";
import AssImpCatalogItem from "../../../../lib/Models/Catalog/Gltf/AssImpCatalogItem";
import CommonStrata from "../../../../lib/Models/Definition/CommonStrata";
import updateModelFromJson from "../../../../lib/Models/Definition/updateModelFromJson";
import Terria from "../../../../lib/Models/Terria";
import { worker } from "../../../mocks/browser";
describe("AssImpCatalogItem", function () {
  let model;
  const terria = new Terria();
  beforeEach(function () {
    model = new AssImpCatalogItem("test", terria);
    updateModelFromJson(model, CommonStrata.override, {
      urls: ["test/AssImp/cube_with_materials.obj", "test/AssImp/cube_with_materials.mtl"],
      baseUrl: "some-base-url/"
    });
    worker.use(http.get("/test/AssImp/cube_with_materials.obj", () => passthrough()), http.get("/test/AssImp/cube_with_materials.mtl", () => passthrough()), http.get("/build/assimpjs.wasm", () => passthrough()));
  });
  it("is Mappable", function () {
    expect(MappableMixin.isMixedInto(model)).toBeTruthy();
  });
  it("creates a DataSource with a model", async function () {
    var _model$mapItems$0$ent;
    await model.loadMapItems();
    expect(model.mapItems.length).toBe(1);
    expect(model.mapItems[0].entities.values.length).toBe(1);
    expect(model.mapItems[0].entities.values[0].polygon).toBeUndefined();
    expect((_model$mapItems$0$ent = model.mapItems[0].entities.values[0].model) === null || _model$mapItems$0$ent === void 0 ? void 0 : _model$mapItems$0$ent.uri).toBeDefined();
  });
  it("applies baseUrl", async function () {
    var _model$mapItems$0$ent2, _gltfJson$buffers, _gltfJson$images;
    await model.loadMapItems();
    const gltfUri = (_model$mapItems$0$ent2 = model.mapItems[0].entities.values[0].model) === null || _model$mapItems$0$ent2 === void 0 ? void 0 : _model$mapItems$0$ent2.uri;
    expect(gltfUri).toBeDefined();
    if (!gltfUri) throw "gltfUri is undefined";
    const blob = await loadBlob(gltfUri.getValue(terria.timelineClock.currentTime));
    const file = new File([blob], "gltf");
    const gltfJson = JSON.parse(await file.text());
    expect((_gltfJson$buffers = gltfJson.buffers) === null || _gltfJson$buffers === void 0 || (_gltfJson$buffers = _gltfJson$buffers[0].uri) === null || _gltfJson$buffers === void 0 ? void 0 : _gltfJson$buffers.startsWith("blob:")).toBeTruthy();
    expect((_gltfJson$images = gltfJson.images) === null || _gltfJson$images === void 0 ? void 0 : _gltfJson$images[0].uri).toBe("some-base-url/cube_texture.png");
  });
  it("supports zip file", async function () {
    var _model$mapItems$0$ent3, _gltfJson$buffers2, _gltfJson$images2;
    model.setTrait(CommonStrata.override, "urls", ["test/AssImp/zip-test.zip"]);
    await model.loadMapItems();
    const gltfUri = (_model$mapItems$0$ent3 = model.mapItems[0].entities.values[0].model) === null || _model$mapItems$0$ent3 === void 0 ? void 0 : _model$mapItems$0$ent3.uri;
    expect(gltfUri).toBeDefined();
    if (!gltfUri) throw "gltfUri is undefined";
    const blob = await loadBlob(gltfUri.getValue(terria.timelineClock.currentTime));
    const file = new File([blob], "gltf");
    const gltfJson = JSON.parse(await file.text());
    expect((_gltfJson$buffers2 = gltfJson.buffers) === null || _gltfJson$buffers2 === void 0 || (_gltfJson$buffers2 = _gltfJson$buffers2[0].uri) === null || _gltfJson$buffers2 === void 0 ? void 0 : _gltfJson$buffers2.startsWith("blob:")).toBeTruthy();
    expect((_gltfJson$images2 = gltfJson.images) === null || _gltfJson$images2 === void 0 || (_gltfJson$images2 = _gltfJson$images2[0].uri) === null || _gltfJson$images2 === void 0 ? void 0 : _gltfJson$images2.startsWith("blob:")).toBeTruthy();
  });
  describe("hasLocalData", function () {
    it("should be false by default", function () {
      expect(model.hasLocalData).toBeFalsy();
    });
    it("should be true if the catalog item has local file data", function () {
      model.setFileInput(new Blob());
      expect(model.hasLocalData).toBeTruthy();
    });
  });
});